import { Doughnut } from "react-chartjs-2";

import { getColor } from "@/utils";

import { BaseWidget } from "./BaseWidget";
import { eventPropsForPie, pieOptions } from "./chart_options";
import { showOneDecimalPlace, sumArray } from "./helpers";

const hasData = (data) =>
  data && data.map((d) => (d.categories || []).length).reduce(sumArray, 0) > 0;

const getLabelsAndDatasets = (key, data) => {
  const LIMIT = 5;

  let datasets = [],
    labels = [],
    backgroundColors = [];

  if (!data) return { labels, datasets };

  // create an object with format `topicname: count`
  // and increase counts if the topic is repeated
  const topics = data.reduce((all, entry) => {
    (entry[key] || []).forEach(([name, count]) => {
      if (!all[name]) all[name] = 0;
      all[name] += count;
    });
    return all;
  }, {});

  // sort by counts and pick top LIMIT topics
  const sortedTopics = Object.keys(topics)
    .sort((a, b) => topics[b] - topics[a])
    .slice(0, LIMIT);

  const topTopics = sortedTopics.reduce((all, each) => {
    all[each] = topics[each];
    return all;
  }, {});

  // convert counts into %
  const total = Object.values(topTopics).reduce(sumArray, 0);

  Object.entries(topTopics).forEach(([name, count], i) => {
    topTopics[name] = showOneDecimalPlace(count, total);
    backgroundColors.push(getColor(i, { title: name, scope: "topic" }));
  });

  // set up labels and datasets
  labels.push(...Object.keys(topTopics));

  datasets.push({
    data: Object.values(topTopics),
    backgroundColor: backgroundColors,
    hoverBackgroundColor: backgroundColors,
    borderWidth: 0,
  });

  return { labels, datasets };
};

const TopicsWidget = (props) => {
  const chartData = getLabelsAndDatasets(
      "categories",
      hasData(props.data) ? props.data : null
    ),
    options = pieOptions();

  return (
    <BaseWidget
      {...props}
      hasData={hasData(props.data)}
      showIsProcessingInfo={true}
    >
      <Doughnut
        data={chartData}
        options={{ ...options, ...eventPropsForPie(chartData, props, "topic") }}
      />
    </BaseWidget>
  );
};

export { TopicsWidget };
